var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c("div", { staticClass: "page" }, [
      _c(
        "div",
        { staticClass: "main-container", attrs: { id: "main-container" } },
        [
          _c(
            "van-tabs",
            {
              attrs: { swipeable: "" },
              on: { change: _vm.tabChange },
              model: {
                value: _vm.active,
                callback: function($$v) {
                  _vm.active = $$v
                },
                expression: "active"
              }
            },
            _vm._l(_vm.tabArr, function(item) {
              return _c(
                "van-tab",
                { key: item.key, attrs: { title: item.value } },
                [
                  _c(
                    "van-pull-refresh",
                    {
                      class: _vm.noData,
                      on: { refresh: _vm.onRefresh },
                      model: {
                        value: _vm.isLoading,
                        callback: function($$v) {
                          _vm.isLoading = $$v
                        },
                        expression: "isLoading"
                      }
                    },
                    [
                      _c(
                        "van-list",
                        {
                          staticClass: "coupon-list",
                          attrs: { finished: _vm.finished, offset: 1 },
                          on: { load: _vm.onLoad },
                          model: {
                            value: _vm.ploading,
                            callback: function($$v) {
                              _vm.ploading = $$v
                            },
                            expression: "ploading"
                          }
                        },
                        [
                          _vm.listShow
                            ? _c(
                                "div",
                                { staticClass: "couponListBox" },
                                _vm._l(_vm.canDoCouponList, function(item) {
                                  return _c(
                                    "div",
                                    { key: item.id, staticClass: "couponList" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "couponListTop" },
                                        [
                                          _c(
                                            "van-row",
                                            [
                                              _c(
                                                "van-col",
                                                {
                                                  staticClass: "vanColOne",
                                                  attrs: { span: "16" }
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.couponSimpleName
                                                          ? item.couponSimpleName
                                                          : item.couponName
                                                          ? item.couponName
                                                          : "--"
                                                      )
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "van-col",
                                                {
                                                  staticClass: "vanColTwo",
                                                  attrs: { span: "8" }
                                                },
                                                [
                                                  _vm._v(
                                                    "¥\n                                                "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.faceAmount
                                                          ? item.faceAmount
                                                          : "0"
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "van-row",
                                            [
                                              _c(
                                                "van-col",
                                                {
                                                  staticClass: "colOne",
                                                  attrs: { span: "16" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                有效期" +
                                                      _vm._s(
                                                        item.couponValidityStart +
                                                          "~" +
                                                          item.couponValidityEnd
                                                      ) +
                                                      "\n                                            "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "van-col",
                                                {
                                                  staticClass: "colTwo",
                                                  attrs: { span: "8" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                满" +
                                                      _vm._s(
                                                        item.thresholdAmount
                                                      ) +
                                                      "元可用\n                                            "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "van-row",
                                        [
                                          _c(
                                            "van-col",
                                            {
                                              staticClass: "couponBottomgq",
                                              style: _vm.userBg(item),
                                              attrs: { span: "24" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    item.remark
                                                      ? item.remark
                                                      : "暂无说明"
                                                  ) +
                                                  "\n                                        "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.finished
                            ? _c("div", { staticClass: "text" }, [
                                !_vm.listShow
                                  ? _c("img", {
                                      attrs: { src: _vm.noListUrl, alt: "" }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("p", [_vm._v("没有无效券了！")])
                              ])
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }